import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { TeamWrapper, TeamLogo, TeamName } from './styles';

import playerImg from '../../../utils/assets/player.jpeg';

const flagImg = 'https://images2.gazzettaobjects.it/matchcenter/static/placeholder/placeholder-shield.svg';


const TeamLabel = ({
  title,
  alt,
  label,
  color,
  size,
  weight,
  marginLeft,
  marginRight,
  marginTop,
  isMatchPageInverse,
  isMatchPage,
  withCursor,
  image,
  nameteam,
  font,
  isPlayer,
  isForma,
  isFlag,
  isWorldCup,
  reverseTitle,
  justifyContent,
  isAColumn,
  isHeader,
  width,
  marginWrapper,
  isStripCalendar,
  noLogo,
  textWidth,
  alignment,
  isUpperCase,
  whiteSpace,
  isCorriereCalendar,
  noFavStar,
  height,
}) => (
  <TeamWrapper
    withCursor={withCursor}
    justifyContent={justifyContent}
    isAColumn={isAColumn}
    marginWrapper={marginWrapper}
    className="boxTeam"
  >
    {isMatchPageInverse &&
    <TeamName
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      color={color}
      size={size}
      weight={weight}
      font={font}
      textWidth={textWidth}
      alignment={alignment}
      whiteSpace={whiteSpace}
      alt={alt}
      title={title}
    >
      {label}
    </TeamName>
    }    {image && !noLogo &&
      (
        <LazyLoad height="100%">
          <TeamLogo
            isPlayer={isPlayer}
            isForma={isForma}
            isFlag={isFlag}
            isWorldCup={isWorldCup}
            isMatchPage={isMatchPage}
            src={image}
            onError={(e) => {
              e.target.src = isPlayer ? playerImg : flagImg;
              e.target.className += ' placeholder';
            }}
            reverseTitle={reverseTitle}
            isHeader={isHeader}
            width={width}
            height={height}
            className="logoTeamHeader"
            isStripCalendar={isStripCalendar}
            isCorriereCalendar={isCorriereCalendar}
            noFavStar={noFavStar}
            alt={nameteam}
            title={nameteam}
          />
        </LazyLoad>
      )
      /*(
        <LazyLoad>
          <TeamLogo
            isPlayer={isPlayer}
            isFlag={isFlag}
            src=""
            reverseTitle={reverseTitle}
            isHeader={isHeader}
            width={width}
            className="logoTeamHeader"
            isStripCalendar={isStripCalendar}
          />
        </LazyLoad>
      )*/
    }
    {!isMatchPageInverse &&
      <TeamName
        marginLeft={marginLeft}
        marginRight={marginRight}
        marginTop={marginTop}
        color={color}
        size={size}
        weight={weight}
        font={font}
        textWidth={textWidth}
        alignment={alignment}
        isUpperCase={isUpperCase}
        whiteSpace={whiteSpace}
        alt={alt}
        title={title}
      >
        {label}
      </TeamName>
    }
  </TeamWrapper>
);

TeamLabel.propTypes = {
  alt: PropTypes.any,
  title: PropTypes.any,
  label: PropTypes.any,
  width: PropTypes.string,
  color: PropTypes.string,
  justifyContent: PropTypes.string,
  size: PropTypes.number,
  weight: PropTypes.string,
  marginRight: PropTypes.number,
  marginLeft: PropTypes.number,
  marginTop: PropTypes.any,
  withCursor: PropTypes.bool,
  image: PropTypes.any,
  nameteam: PropTypes.any,
  font: PropTypes.any,
  isPlayer: PropTypes.bool,
  isForma: PropTypes.bool,
  isFlag: PropTypes.bool,
  reverseTitle: PropTypes.bool,
  isMatchPage: PropTypes.bool,
  isMatchPageInverse: PropTypes.bool,
  isAColumn: PropTypes.bool,
  isHeader: PropTypes.bool,
  marginWrapper: PropTypes.string,
  isStripCalendar: PropTypes.bool,
  noLogo: PropTypes.bool,
  textWidth: PropTypes.string,
  alignment: PropTypes.string,
  isWorldCup: PropTypes.bool,
  isUpperCase: PropTypes.bool,
  whiteSpace: PropTypes.string,
  isCorriereCalendar: PropTypes.bool,
  noFavStar: PropTypes.bool,
  height: PropTypes.any,
};

export default TeamLabel;



// WEBPACK FOOTER //
// ./src/components/shared/TeamLabel/index.js